/**
 * Component Toggle content innerblocks
 */
 var component_toggle_content_innerblocks = function() {

  // setup args
  var detailsElements = document.querySelectorAll('.toggle-content-innerblocks details');

  // validate
  if (!detailsElements) {
    console.log('no details element suplied');
    return;
  }

  /**
   * Init
   */
  function init_component_toggle_content_innerblocks() {

    detailsElements.forEach((targetDetail, index) => {

      var summary = targetDetail.querySelector('summary');

      if (index == 0) {
        // set first details element open
        targetDetail.open = true;

        // set min height based on wo-block-group inside details
        var group = targetDetail.querySelector('.wp-block-group');
        var groupHeight = group.getBoundingClientRect().height;
        targetDetail.parentElement.style.minHeight = groupHeight + 'px';
      }

      summary.addEventListener("click", (e) => {

        detailsElements.forEach((detail) => {

          // dont close details element if it's already open
          if (detail.open == true) {
            e.preventDefault();
          }

          if (detail == targetDetail) {
            // set clicked details element open
            detail.open = true;

            // set min height based on wo-block-group inside details
            var group = targetDetail.querySelector('.wp-block-group');
            var groupHeight = group.getBoundingClientRect().height;
            targetDetail.parentElement.style.minHeight = groupHeight + 'px';
          } else {
            // close other details elements and set height to auto
            detail.open = false;
            detail.style.minHeight = 'auto';
          }

        });
      });
    });

    return;
  }
  init_component_toggle_content_innerblocks();

  // make the call chainable
  return this;
};
